import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from "@angular/core";

@Component({
  selector: 'grabbill-client-whatsapp-stat',
  templateUrl: './whatsapp-stat.component.html',
  styleUrls: ['./whatsapp-stat.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WhatsappStatComponent {

  @Input()
  total: number = 0;

  @Input()
  totalSent: number = 0;

  @Input()
  totalSkip: number = 0;

  @Input()
  totalDelivered: number = 0;

  @Input()
  totalRead: number = 0;

  @Input()
  totalAcknowledge: number = 0;

  @Input()
  totalFailed: number = 0;

  // Which stat box's filter is currently applied by the parent (or null/
  // undefined for none) - drives the `.active` highlight below.
  @Input()
  activeFilter: string | null = null;

  // True when the Record Status / WhatsApp Status dropdown filters (owned
  // by the parent) are narrowing the table - so the Total box only claims
  // "showing everything" when that's actually true, not just when no stat
  // box happens to be clicked.
  @Input()
  hasOtherFiltersActive: boolean = false;

  // Emits the clicked box's key ('sent'/'delivered'/'read'/'acknowledged'/
  // 'skip'/'failed'), or null for the Total box. Toggle/switch logic lives
  // in the parent - this component just reports what was clicked.
  @Output()
  filterChange = new EventEmitter<string | null>();
}
